import Home from './components/Home';
import EditingInterface from './components/EditingInterface';
import Login from './components/Login';
import ChangePassword from './components/ChangePassword';
import Tables from './components/Tables';
import AddRecords from  './components/AddRecords';
import CreateUser from './components/CreateUser'
import ModifyUser from  './components/ModifyUser'
import UploadDistrictBoundaries from './components/UploadDistrictBoundaries';
import SimplifyDistrictBoundaries from './components/SimplifyDistrictBoundaries';
import EditHistory from './components/EditHistory';
import RecordEditHistory from './components/RecordEditHistory';
import UltralocalOfficeProcessing from './components/UltralocalOfficeProcessing';
import UltralocalBatches from './components/UltralocalBatches';
import GenericFileUpload from './components/GenericFileUpload';
import DataCorrection from './components/DataCorrection';
import MultiTable from './components/MultiTable'; 
const routes = [
    { path: '/', redirect: '/login' },
    { path: '/home', component: Home },
    { path: '/tables/:table', component: Tables, meta: { requireAuth: true } },
    { path: '/add/:table', component: AddRecords,meta: { requireAuth: true } },
    { path: '/editinginterface/', component: EditingInterface, meta: { requireAuth: true } },
    { path: '/login', component: Login },
    { path: '/settings/changepassword', component: ChangePassword },
    { path: '/settings/history', component: EditHistory,meta: { requireAuth: true } },
    { path: '/settings/recordhistory', component: RecordEditHistory,meta: { requireAuth: true } },
    { path: '/settings/clearSchemaCache', beforeEnter: (to, from, next) => {                                                                                                                                                           localStorage.removeItem('schema_tables');                                                                                                                                            
        alert('Schema cache cleared.');                                                                                                                                                      
        next(from.path || '/home');
        }
    },
    { path: '/admin/createUser', component: CreateUser,meta: { requireAuth: true } },
    { path: '/admin/modifyUser/:table', component: ModifyUser,meta: { requireAuth: true } },
    { path: '/admin/uploadDistrictBoundaries', component: UploadDistrictBoundaries,meta: { requireAuth: true } },
    { path: '/admin/simplifyDistrictBoundaries', component: SimplifyDistrictBoundaries, meta: { requireAuth: true } },
    { path: '/ultralocal/:table', component: UltralocalOfficeProcessing, meta: { requireAuth: true } },
    { path: '/batches/:table', component: UltralocalBatches, meta: { requireAuth: true } },
    { path: '/file_upload', component: GenericFileUpload, meta: { requireAuth: true } },
    { path: '/data_correction', component: DataCorrection, meta: { requireAuth: true } },
    { path: '/multitable/:name', component: MultiTable, meta: { requireAuth: true } },
]

export default routes;
